import React from 'react';
import clsx from 'clsx';

import {
  CheckCircleOutline as CheckIcon,
  ErrorOutline as ErrorIcon,
  ReportProblemOutlined as WarningIcon
} from '@mui/icons-material';

import { darken, lighten, Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

type AlertProps = {
  children: React.ReactNode;
  variant: 'success' | 'warning' | 'error';
};

const useStyles = makeStyles((theme: Theme) => {
  const getBackgroundColor = theme.palette.mode === 'light' ? lighten : darken;

  return {
    container: {
      display: 'flex',
      padding: '0.85em',
      borderRadius: theme.shape.borderRadius,
      '&:not(:last-child)': {
        marginBottom: '0.8em',
      },
      '& svg': {
        margin: '0 0.6em 0 0.3em',
        padding: '1px',
      },
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    success: {
      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
      '& svg': {
        fill: theme.palette.success.main,
      },
    },
    warning: {
      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
      '& svg': {
        fill: theme.palette.warning.main,
      },
    },
    error: {
      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
      '& svg': {
        fill: theme.palette.error.main,
      },
    },
  };
});

export default function Alert({ variant, children }: AlertProps) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.container, classes[variant])}>
      {variant === 'success' && <CheckIcon />}
      {variant === 'warning' && <WarningIcon />}
      {variant === 'error' && <ErrorIcon />}
      <div className={classes.contentContainer}>{children}</div>
    </div>
  );
}
